import React from 'react';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

import { toAuctionType } from 'src/lib/toAuctionType';
import { UpcomingAuctionsButtonContainer, AuctionPreviewButtonsGap, AuctionPreviewButtonsIndividualContainer }
  from 'src/components/AuctionPreview/AuctionPreviewContent/AuctionPreviewContent.style';
import { UpcomingAuctionContainer } from 'src/components/UpcomingAuction/UpcomingAuction.style';
import { BoxButton } from '@riac/design-system';
import { ArrowLink } from '@riac/design-system';
import { AuctionDate } from '../AuctionDate/AuctionDate';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(isSameOrBefore);

export const UpcomingAuction = ({ auction }) => {
  const now = dayjs().tz('America/Chicago');
  const toNextAuction = (date) => {
    const m = Math.round(dayjs.tz(date).diff(now, 'month', true));
    const d = Math.ceil(dayjs.tz(date).diff(now, 'day', true));
    if(d >= 28) return `${m} month${m !== 1 ? 's' : ''}`;

    return `${d} day${d !== 1 ? 's' : ''}`;
  };

  let live = false;
  let current = false;
  let dayOver = false;

  let time = '';

  try {
    time = dayjs.tz(`${auction.StartDate} ${auction.StartTime}`).format('H:mm a');
  } catch (e) {
    console.error(e);
  }

  if(auction.active) {
    live = true;
  }
  if(dayjs.tz(auction.StartDate).isSameOrBefore(now, 'day') && now.isSameOrBefore(dayjs.tz(auction.EndDate), 'day')) {
    current = true;
  }

  let todaySession;
  let tomorrowSession;
  if(auction.sessions) {
    auction.sessions.forEach((session) => {
      if(session.Date === now.format('YYYY-MM-DD')) {
        todaySession = session;
      }
      if(session.Date === now.add(1, 'day').format('YYYY-MM-DD')) {
        tomorrowSession = session;
      }
    });
  }

  if(current && !live && todaySession?.AuctionSessionStatus === 4) {
    dayOver = true;
  }
  // <ONE TIME HACK REPLACE ME>
  if(auction.AuctionID == 2094) {
    auction.Subtitle = 'Guns & Coffee';
  }
  // </ONE TIME HACK REPLACE ME>

  return (
    <UpcomingAuctionContainer key={auction.AuctionID}>
      <strong>{auction.Title}</strong>
      {auction.Subtitle &&
        <div>{auction.Subtitle}</div>
      }
      <AuctionDate
        auction = {auction}
        startDateFormat = 'MMMM Do, YYYY'
        endDateFormat= 'MMMM Do, YYYY'
        omitTime
      />
      {/* Don't show if auction is over */}
      {now.isSameOrBefore(dayjs(auction.EndDate), 'day')
        && <React.Fragment>
          {live
            && <p>Live Now!</p>
          }
          {live
            && <div><BoxButton to={'/live'} target='' rel=''>Bid Live</BoxButton></div>
          || dayOver && (
            tomorrowSession
              && <p>
                Auction has completed for the day.<br/>
                Join us tomorrow for lots #{tomorrowSession?.StartingLot} - #{tomorrowSession?.EndingLot}
              </p>
            || <p>
                Auction has completed<br/>
                Check back soon for prices realized
            </p>
          ) || current
            && <>
              {auction.AuctionTypeID === TIMED_AUCTION_TYPE_ID
                && <p>
                  Auction is currently live!<br/>
                </p>
              || <p>
                  Auction starts today at {time}<br/>
                  Auctioning lots #{todaySession?.StartingLot} - #{todaySession?.EndingLot}
              </p>
              }
            </>
          || <p>
            {toNextAuction(auction.StartDate)} to our
              next {toAuctionType(auction.AuctionTypeID)} Auction!
          </p>
          }
          <UpcomingAuctionsButtonContainer>
            {auction.AuctionTypeID === 1
              && <>
                <AuctionPreviewButtonsIndividualContainer>
                  <ArrowLink to='/order-catalog'>
                    Order Catalog
                  </ArrowLink>
                </AuctionPreviewButtonsIndividualContainer>
                <AuctionPreviewButtonsGap/>
              </>
            }
            {auction.CatalogSearchLink
              ? <AuctionPreviewButtonsIndividualContainer>
                <ArrowLink to={`/catalog/${auction.AuctionID}`}>
                  View Catalog
                </ArrowLink>
              </AuctionPreviewButtonsIndividualContainer>
              : null
            }
          </UpcomingAuctionsButtonContainer>
        </React.Fragment>
        || <AuctionPreviewButtonsIndividualContainer>
          <ArrowLink to={`/catalog/${auction.AuctionID}`}>
            View Past Catalog
          </ArrowLink>
        </AuctionPreviewButtonsIndividualContainer>
      }
    </UpcomingAuctionContainer>
  );
};
